module.exports = __webpack_public_path__ + "8a5356e9/img/revit-icon.5ff0d581.svg";